// import { login, logout, getInfo } from '@framework/api/user'
import { getToken, setToken, removeToken } from '@framework/utils/auth'
import router, { resetRouter } from '../../router'

const state = {
  token: getToken(),
  'balance': 0,
  'company': '',
  'mobile': '',
  'userId': '',
  orderInfo: null,
  role: '',
  isAdmin: false,
  hasCompany: false
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, info) => {
    Object.assign(state, info)
    state.isAdmin = state.role === 1 || state.role === 3
    state.hasCompany = state.role !== 0
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLE: (state, role) => {
    state.role = +role
    state.isAdmin = state.role === 1 || state.role === 3
    state.hasCompany = state.role !== 0
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // user login
  login(store, userInfo) {
    return new Promise(async(resolve, reject) => {
      try {
        const res = await this.$http(this.$api.login, userInfo)
        store.commit('SET_TOKEN', res.token)
        store.commit('SET_ROLE', res.role)
        setToken(res.token)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise(async(resolve, reject) => {
      const res = await this.$http(this.$api.getUserInfo)
      const orderCount = await this.$http(this.$api.orderGetTodayOrderCount)
      res.orderCount = orderCount
      commit('SET_USERINFO', res)
      resolve(res)
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resetRouter()
      resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const { roles } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
